﻿<script>
	import { Router, Route, navigate } from "svelte-navigator";

	import { projectSettings } from "../config";

	import registrationPageList from "./Registration/routes";
	import FormColumn from "../components/FormColumn.svelte";
	import NavigationTracker from "../components/NavigationTracker.svelte";

	export let url = "";

	let trackerPageList = registrationPageList;
	const checkLandingUrl = function () {
		if (window.location.pathname.indexOf(`${projectSettings.basePath}Registration`) >= 0) {
			trackerPageList = registrationPageList;

			if (window.location.pathname !== `${projectSettings.basePath}Registration`) {
				navigate(`${projectSettings.basePath}Registration`);
			}
		} else if (window.location.pathname.indexOf(`${projectSettings.basePath}Review`) >= 0) {
			trackerPageList = registrationPageList;

			if (window.location.pathname !== `${projectSettings.basePath}Review`) {
				navigate(`${projectSettings.basePath}Review`);
			}

			return false;
		} else if (
			window.location.pathname.indexOf(`${projectSettings.basePath}Registration`) < 0 &&
			window.location.pathname.indexOf(`${projectSettings.basePath}Review`) < 0
		) {
			trackerPageList = registrationPageList;
			navigate(`${projectSettings.basePath}Registration`);
		}

		return true;
	};

	if (checkLandingUrl()) {
		window.onbeforeunload = (event) => {
			event.returnValue = `Are you sure you want to leave?`;
		};
	}
</script>

<Router {url}>
	<div class="row">
		<FormColumn cols="2"></FormColumn>
		<FormColumn cols="8">
			<NavigationTracker pageList={trackerPageList} />

			{#each trackerPageList as page, i}
				<Route path={page.routeId}>
					<svelte:component this={page.component} {...page.properties} pageName={page.title} />
				</Route>
			{/each}
		</FormColumn>
		<FormColumn cols="2"></FormColumn>
	</div>
</Router>

<style>
	.row {
		min-height: calc(100vh - 505px);
	}
</style>
